import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCallDuration, setTimerStarted } from "../../../../reducers/common-reducer";

const TimerComponent = () => {
    const { isRemoteParticipantJoined } = useSelector((state) => state.commonReducer);
    const [timer, setTimer] = useState({ hour: 0, minute: 0, second: 0 });
    const dispatch = useDispatch();
    /* Function to pad zeros to single-digit values, it is used for append 0 and format timer like 00:00 */
    const padZero = (value) => {
        return value < 10 ? "0" + value : value;
    };

    // Memoize the formatted timer value to prevent unnecessary re-renders
    useMemo(() => {
        dispatch(setCallDuration(`${timer.hour > 0 ? padZero(timer.hour) + ":" : ""}${padZero(timer.minute)}:${padZero(timer.second)}`));
    }, [timer]);

    /* This useeffect used to set timer when agent and guest join the call */
    useEffect(() => {
        let timerInterval,
            isFirstTime = true;
        if (isRemoteParticipantJoined) {
            timerInterval = setInterval(() => {
                if (isFirstTime) {
                    isFirstTime = false;
                    dispatch(setTimerStarted(true));
                }
                updateTimer();
            }, 1000);
        }
        // Clean up the interval when the component unmounts or when Token becomes false
        return () => {
            clearInterval(timerInterval);
            dispatch(setTimerStarted(false));
        };
    }, [isRemoteParticipantJoined]);

    /* This function update time and return hour, minute and second */
    const updateTimer = () => {
        setTimer((prevTimer) => {
            let { hour, minute, second } = prevTimer;
            second++;

            if (second === 60) {
                second = 0;
                minute++;

                if (minute === 60) {
                    minute = 0;
                    hour++;
                }
            }

            return { hour, minute, second };
        });
    };

    return <></>;
};

export default TimerComponent;
